import style from './style.css';
import React from 'react'
import {Div} from '/app/src/component'

export default class HeaderArrow extends React.Component {
    render() {
        let customStyle = {

        }
        let{circleBorder, small, direction, border, rest} = this.props

        if(circleBorder){
            border='circle-'+direction
        }
        let transform= 'none'
        if(small){
            transform='scale(0.5)'
        }

        return (
            <Div style={customStyle} className={style.Arrow} onClick={this.props.onClick} {...rest} transform={transform}>
                <i className={style['arrow-'+direction]}/>
                <div className={style[border]}/>
            </Div>
        )
    }
}



// WEBPACK FOOTER //
// src/component/Arrow/index.js